<template>
	<div class="vue-cropper2">
		<el-upload class="avatar-uploader" :class="{'round':shape==='round'}"
			:style="{'margin-left':align==='left'?'0':'auto'}" action="" :auto-upload="false" :show-file-list="false"
			:on-change='upicon'>
			<img v-if="icon" :src="icon" class="avatar">
			<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
		<el-dialog class="vue-cropper2-dialog" title="图片剪裁" :visible.sync="cropper" append-to-body width="800px">
			<div style="height: 600px;">
				<div class="cropper" style=" height: 100%; width: 100%; float: left;">
					<el-popover placement="right" title="预览" :width="width" trigger="hover">
						<vue-cropper slot="reference" ref="cropper" :img="cropper_imgurl" :outputSize="1"
							outputType="png" :info="true" :canScale="true" :autoCrop="true" :autoCropWidth="width"
							:autoCropHeight="height" :fixed="true" :fixedNumber="[1,height/width]" :full="false"
							:fixedBox="true" :canMove="false" :canMoveBox="true" :original="false" :centerBox="true"
							:height="true" :infoTrue="false" :enlarge="1" @realTime="realTime">
						</vue-cropper>
						<div :style="cropper_icon.div" style="overflow: hidden; ">
							<img :src="cropper_icon.url" :style="cropper_icon.img" />
						</div>
					</el-popover>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<div style="float: left;">
					<el-button icon="el-icon-circle-plus-outline" @click="changeScale(1)">放大</el-button>
					<el-button icon="el-icon-remove-outline" @click="changeScale(-1)">缩小</el-button>
					<el-button icon="el-icon-refresh-left" @click="rotateLeft()">左旋转</el-button>
					<el-button icon="el-icon-refresh-right" @click="rotateRight()">右旋转</el-button>
				</div>
				<el-button @click="cropper = false">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="uploadImg()">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			defaultIcon: {
				type: String
			},
			file_type: {
				type: String,
				default: null
			},
			width: {
				type: Number,
				default: 100
			},
			height: {
				type: Number,
				default: 100
			},
			shape: {
				type: String,
				default () {
					return 'round' //round, square
				}
			},
			align: {
				type: String,
				default () {
					return 'left' //left  
				}
			},
			path: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				loading: false,
				icon: '',
				cropper: false,
				cropper_imgurl: '',
				cropper_icon: {},
			}
		},
		watch: {
			'defaultIcon': {
				handler: function(newVal, oldVal) {
					this.icon = newVal
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			setIcon(url) {
				this.icon = url
			},
			upicon(file, fileList) {
				const isLt5M = file.size / 1024 / 1024 < 5
				const isJPG = this.file_type && this.file_type.indexOf(file.raw.type) > -1

				if (!isLt5M) {
					this.$message.error('上传文件大小不能超过 5MB!')
					return false
				}
				if (this.file_type && !isJPG) {
					this.$message.error('上传头像图片只能是 ' + this.file_type + ' 格式!');
					return false
				}
				this.fileinfo = file

				// 上传成功后将图片地址赋值给裁剪框显示图片
				this.$nextTick(() => {
					this.cropper_imgurl = URL.createObjectURL(file.raw)
					this.cropper = true
				})
			},
			uploadImg() {
				let _this = this;
				//获取截图的blob数据
				this.$refs.cropper.getCropBlob(async (data) => {
					let formData = new FormData();
					let file = new File([data], 'DX.png', {
						type: data.type,
						lastModified: Date.now()
					});
					formData.append("file", file, "DX.png")
					formData.append("path", this.path)
					//调用axios上传
					let res = await _this.$http.post('api/ToolApi/UpFiles', formData)
					if (res.status === 200) {
						_this.icon = this.$http.fileUrl + res.data.data
						_this.cropper = false
						this.$emit('upfile', _this.icon)
					} else {
						_this.$message({
							message: '文件服务异常，请联系管理员！',
							type: "error"
						});
					}
				})
			},
			realTime(data) {
				this.cropper_icon = data
			},
			//图片缩放
			changeScale(num) {
				num = num || 1
				this.$refs.cropper.changeScale(num)
			},
			//向左旋转
			rotateLeft() {
				this.$refs.cropper.rotateLeft()
			},
			//向右旋转
			rotateRight() {
				this.$refs.cropper.rotateRight()
			}
		}
	}
</script>

<style lang="scss">
	.vue-cropper2 {
		.avatar-uploader {
			line-height: 0px;
			width: 100px;
			margin: auto;
		}

		.avatar-uploader {
			.el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 50%;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}

			&.round {
				.el-upload {
					border-radius: 10px;
				}
			}
		}

		.avatar-uploader .el-upload:hover {
			border-color: #409EFF;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 100px;
			height: 100px;
			line-height: 100px;
			text-align: center;
		}

		.avatar {
			height: 100px !important;
			// width: 100px !important;
			display: block;
		}

		.head-icon {
			>label {
				line-height: 100px;
			}
		}
	}


	.vue-cropper2-dialog {
		.el-dialog {
			border-radius: 10px;
		}

		.el-dialog__body {
			padding: 0;
		}

		.el-dialog__footer {
			padding: 10px;
		}
	}
</style>
